import { c as _c } from "react/compiler-runtime";
import React from "react";
import { roundToQuarterInch } from "@/lib/measurement-utils";
import { cx } from "@/lib/tailwind-utils";
import Input from "./input";
interface HeightInputProps {
  value: HeightValue;
  onChange: (value: HeightValue) => void;
  hasError?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  /** Accept inches in quarters (6.25, 6.5, 6.75) instead of whole inches only. */
  quarterInches?: boolean;
}
interface HeightValue {
  feet: string;
  inches: string;
}
const HeightInput: React.FC<HeightInputProps> = t0 => {
  const $ = _c(53);
  const {
    value: t1,
    onChange,
    hasError: t2,
    errorMessage,
    disabled: t3,
    fullWidth: t4,
    className,
    quarterInches: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      feet: "",
      inches: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const value = t6;
  const hasError = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const fullWidth = t4 === undefined ? false : t4;
  const quarterInches = t5 === undefined ? false : t5;
  const maxInches = quarterInches ? 11.75 : 11;
  const t7 = fullWidth && "flex-1";
  let t8;
  if ($[2] !== t7) {
    t8 = cx("relative", t7);
    $[2] = t7;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const boxClassName = t8;
  const t9 = !fullWidth && "w-20";
  let t10;
  if ($[4] !== t9) {
    t10 = cx("pr-7", t9);
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const inputClassName = t10;
  let t11;
  if ($[6] !== className) {
    t11 = cx("flex flex-col", className);
    $[6] = className;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== onChange || $[9] !== value) {
    t12 = e => {
      const val = Number(e.target.value);
      if (Number.isInteger(val)) {
        onChange({
          ...value,
          feet: Math.min(Math.floor(val), 8).toString()
        });
      }
    };
    $[8] = onChange;
    $[9] = value;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== disabled || $[12] !== hasError || $[13] !== inputClassName || $[14] !== t12 || $[15] !== value.feet) {
    t13 = <Input className={inputClassName} type="number" value={value.feet} onChange={t12} min={0} max={8} hasError={hasError} disabled={disabled} onKeyDown={_temp} />;
    $[11] = disabled;
    $[12] = hasError;
    $[13] = inputClassName;
    $[14] = t12;
    $[15] = value.feet;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-body text-foreground-tertiary">ft</span>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== boxClassName || $[19] !== t13) {
    t15 = <div className={boxClassName}>{t13}{t14}</div>;
    $[18] = boxClassName;
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  let t17;
  if ($[21] !== maxInches || $[22] !== onChange || $[23] !== quarterInches || $[24] !== value) {
    t16 = e_1 => {
      const raw = e_1.target.value;
      const val_0 = Number(raw);
      if (quarterInches) {
        if (raw === "" || !isNaN(val_0) && val_0 >= 0) {
          onChange({
            ...value,
            inches: val_0 > maxInches ? String(maxInches) : raw
          });
        }
      } else {
        if (Number.isInteger(val_0)) {
          onChange({
            ...value,
            inches: Math.min(Math.floor(val_0), maxInches).toString()
          });
        }
      }
    };
    t17 = () => {
      if (quarterInches && value.inches !== "") {
        const val_1 = Number(value.inches);
        if (!isNaN(val_1)) {
          onChange({
            ...value,
            inches: String(Math.min(roundToQuarterInch(val_1), maxInches))
          });
        }
      }
    };
    $[21] = maxInches;
    $[22] = onChange;
    $[23] = quarterInches;
    $[24] = value;
    $[25] = t16;
    $[26] = t17;
  } else {
    t16 = $[25];
    t17 = $[26];
  }
  const t18 = quarterInches ? 0.25 : 1;
  let t19;
  if ($[27] !== quarterInches) {
    t19 = e_2 => {
      if (!quarterInches && (e_2.key === "." || e_2.key === ",")) {
        e_2.preventDefault();
      }
    };
    $[27] = quarterInches;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== disabled || $[30] !== hasError || $[31] !== inputClassName || $[32] !== maxInches || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== value.inches) {
    t20 = <Input className={inputClassName} type="number" value={value.inches} onChange={t16} onBlur={t17} min={0} max={maxInches} step={t18} hasError={hasError} disabled={disabled} onKeyDown={t19} />;
    $[29] = disabled;
    $[30] = hasError;
    $[31] = inputClassName;
    $[32] = maxInches;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = value.inches;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-body text-foreground-tertiary">in</span>;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== boxClassName || $[41] !== t20) {
    t22 = <div className={boxClassName}>{t20}{t21}</div>;
    $[40] = boxClassName;
    $[41] = t20;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t15 || $[44] !== t22) {
    t23 = <div className="flex gap-2">{t15}{t22}</div>;
    $[43] = t15;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== errorMessage || $[47] !== hasError) {
    t24 = hasError && errorMessage && <p id="error-message" className="mt-1.5 text-caption text-status-error-text">{errorMessage}</p>;
    $[46] = errorMessage;
    $[47] = hasError;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t11 || $[50] !== t23 || $[51] !== t24) {
    t25 = <div className={t11}>{t23}{t24}</div>;
    $[49] = t11;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  return t25;
};
export default HeightInput;
export type { HeightValue };
function _temp(e_0) {
  if (e_0.key === "." || e_0.key === ",") {
    e_0.preventDefault();
  }
}